import {ChangeDetectionStrategy, Component, inject, input} from '@angular/core';
import {defectButtons} from "../../../configs/product-card-defects-config";
import {MatDialog} from "@angular/material/dialog";
import {ProductCardsDefectsService} from "../../../services/product-cards-defects.service";
import {ErrorService} from "../../../../../../core/services/error.service";
import {
  defaultRecordsDataRequestQueryParams
} from "../../../../../../core/models/default-records-data-request-query-params";
import {RecordsDataRequestQueryParams} from "../../../../../../core/types/records-table.types";
import {ProductCardDefect} from "../../../types/product-card-defect.types";
import {
  ProductCardDefectModalComponent
} from "../../modals/product-card-defect-modal/product-card-defect-modal.component";
import {
  ProductCardDefectValueModalComponent
} from "../../modals/product-card-defect-value-modal/product-card-defect-value-modal.component";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'app-pc-defects',
  standalone: true,
  imports: [
    MatButton
  ],
  templateUrl: './pc-defects.component.html',
  styleUrl: './pc-defects.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PcDefectsComponent {
  productCardId = input<number>(0);

  private productCardsDefectsService: ProductCardsDefectsService = inject(ProductCardsDefectsService);
  private dialog = inject(MatDialog);
  private errorService: ErrorService = inject(ErrorService);

  public readonly defectButtons = defectButtons;

  public async handleOpenModal(key: string): Promise<void> {
    const defects = await this.getProductCardDefects();
    key === 'defect' ?
      this.openProductCardDefectModal(defects) :
      this.openProductCardDefectValueModal(defects);
  }

  private openProductCardDefectModal(defects: Array<ProductCardDefect>): void {
    this.dialog.open(ProductCardDefectModalComponent, {
      data: {
        productCardId: this.productCardId(),
        defects: defects
      }
    }).afterClosed().subscribe(async () => {

    });
  }

  private openProductCardDefectValueModal(defects: Array<ProductCardDefect>): void {
    if (!defects.length) {
      this.errorService.showErrorMessage('Сразу надо создать "Элемент товара"!');
      return;
    }

    this.dialog.open(ProductCardDefectValueModalComponent, {
      data: {
        defects: defects,
        productCardId: this.productCardId()
      }
    }).afterClosed().subscribe(async () => {

    });
  }

  private async getProductCardDefects(): Promise<Array<ProductCardDefect>> {
    const queryParams: RecordsDataRequestQueryParams = {
      ...defaultRecordsDataRequestQueryParams,
      size: undefined,
      productCardId: this.productCardId()
    };

    return await this.productCardsDefectsService.getProductCardsDefects(queryParams).catch(() => []);
  }
}
